var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-question-container"},[_c('div',{staticClass:"view-option-container"},[(_vm.imgSrc != '')?_c('img',{staticClass:"view-textImg",attrs:{"src":_vm.imgSrc}}):_vm._e(),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"rows":"1","placeholder":"Your answer"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a90bef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/survey-create/search-templates-components/ViewTextAnswer.vue
// module id = null
// module chunks = 